module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/stopwatch-50e3994d5616533289fec611a86bc2e6.svg";